var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGImgEmptyMarketingAutomation = function SvgGImgEmptyMarketingAutomation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 19.8,
    width: 52.4,
    height: 40.4,
    rx: 1.2,
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 26.5,
    width: 39,
    height: 14,
    rx: 1.5,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 51,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#BDBDBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    d: "m64.269 21.58-2.2 3.811"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.205 12.428a1.573 1.573 0 0 1 2.148-.576l5.07 2.927a1.573 1.573 0 0 1-1.508 2.76l-1.048 1.814a5.293 5.293 0 0 1 .212 5.632.212.212 0 0 1-.289.078l-10.026-5.789a.212.212 0 0 1-.077-.289 5.293 5.293 0 0 1 4.984-2.632l1.048-1.815a1.573 1.573 0 0 1-.514-2.11z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m66.353 11.852-.4.693.4-.693zm5.07 2.927.4-.692-.4.692zm-1.508 2.76.368-.711-.679-.352-.382.662.693.4zm-1.048 1.814-.693-.4-.251.435.283.415.661-.45zm-.077 5.71-.4.692.4-.692zm-10.026-5.789.4-.693-.4.693zm4.907-2.921-.06.797.501.038.252-.435-.693-.4zm1.048-1.815.692.4.383-.662-.644-.412-.431.674zm2.034-3.379a2.373 2.373 0 0 0-3.24.869l1.385.8a.773.773 0 0 1 1.055-.283l.8-1.386zm5.07 2.928-5.07-2.928-.8 1.386 5.07 2.927.8-1.385zm.869 3.24a2.373 2.373 0 0 0-.868-3.24l-.8 1.385c.37.214.496.686.282 1.056l1.386.8zm-3.145.921c1.12.58 2.508.183 3.145-.92l-1.386-.8a.773.773 0 0 1-1.023.3l-.737 1.42zm.013 1.505 1.047-1.815-1.385-.8-1.048 1.815 1.386.8zm-1.354.05a4.493 4.493 0 0 1 .18 4.782l1.386.8a6.093 6.093 0 0 0-.244-6.483l-1.322.901zm.18 4.782a.588.588 0 0 1 .804-.215l-.8 1.385c.484.28 1.103.114 1.382-.37l-1.386-.8zm.804-.215L59.164 18.58l-.8 1.386 10.026 5.788.8-1.385zM59.164 18.58a.588.588 0 0 1 .216.804l-1.386-.8a1.012 1.012 0 0 0 .37 1.382l.8-1.386zm.216.804a4.493 4.493 0 0 1 4.231-2.235l.12-1.595a6.093 6.093 0 0 0-5.737 3.03l1.386.8zm4.646-5.247-1.048 1.815 1.386.8 1.047-1.815-1.385-.8zm-.514-2.11a2.373 2.373 0 0 0 .775 3.184l.863-1.348a.773.773 0 0 1-.252-1.036l-1.386-.8z",
    fill: "#BDBDBD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGImgEmptyMarketingAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/-g-img_empty_marketing_automation.87aee0d5385692bca7eaec4b40c73df3.svg";